import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {withStyles} from '@material-ui/core/styles';
import {ClickAwayListener, Grid} from '@material-ui/core';
import AppAppBar from 'Navigation/Presentation/AppAppBar';
import AppContent from 'Navigation/Presentation/AppContent';
import AppDrawer from 'Navigation/Presentation/AppDrawer';

const drawerWidth = 240;
const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundImage:
      process.env.REACT_APP_SANDBOX === 'true' ||
      !process.env.REACT_APP_BACKGROUND_IMAGE
        ? 'none'
        : `url("${process.env.REACT_APP_BACKGROUND_IMAGE}")`,
    paddingRight: 24,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    paddingRight: 0,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  drawerListItem: {
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  title: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'center',
    paddingLeft: theme.spacing(3),
  },
  toolbar: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
    height: '100vh',
  },
});

function Navigation(props) {
  const {children, classes, onCloseDrawer} = props;

  return (
    <div className={` printDisplayBlock ${classes.root}`}>
      <Helmet titleTemplate={`%s | ${process.env.REACT_APP_APP_NAME} `} />
      <ClickAwayListener onClickAway={onCloseDrawer}>
        <Grid>
          <AppAppBar {...props} />
          <AppDrawer {...props} />
        </Grid>
      </ClickAwayListener>
      <AppContent {...props}>{children}</AppContent>
    </div>
  );
}

Navigation.propTypes = {
  children: PropTypes.element.isRequired,
  classes: PropTypes.object.isRequired,
  onCloseDrawer: PropTypes.func.isRequired,
};

export default withStyles(styles)(Navigation);
